<template>
  <a-modal :visible="showDialog" :mask="false" :title="title" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="离职人员：">
       {{userInfo.name}}
     </a-form-item>
     <a-form-item label="交接人员：">
       <a-select v-model="handoverUserId" style="width: 200px" allowClear
                  :maxTagCount="1" placeholder="请选择交接人员"
                  optionFilterProp="label" show-search>
          <a-select-option v-for="userItem in userList"
                           :label="userItem.name"
                           :value="userItem.id"
                           :key="userItem.id">
            {{userItem.name}}
          </a-select-option>
        </a-select>
     </a-form-item>
    
   </a-form>
  </a-modal>
</template>
<script>
import {QuitHandover} from "../../api/v1/user_api";

export default {
  name: "QuitDialog",
  props:['userInfo','showDialog','userList','title'],
  data(){
    return {
      handoverUserId:'',
    }
  },
  methods:{
    handleOk(){
      if (this.userInfo.id == this.handoverUserId) {
          this.$message.error('交接人员不能和离职人员相同！')
          return 
      }
      if (!this.handoverUserId) {
          this.$message.error('请选择交接人员')
          return 
      }
      let data = {
        "quitUserId":this.userInfo.id,
        "handoverUserId":this.handoverUserId
      }
      QuitHandover(data).then(resp => {
        if (resp.code===200){
          this.$message.success('离职交接成功')
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.handoverUserId = ''
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/QuitDialog.vue